
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { DragBox } from 'ol/interaction';
import { noModifierKeys } from 'ol/events/condition';
import { getHeight, getWidth } from 'ol/extent';
export function drawZoomBox(map: any, mapService: any, toolName: any, counter: any, toolActive: any, ipAddress: any): any {
    const zoomDrawSource = new VectorSource();
    mapService.zoomLayer = new VectorLayer({
        source: zoomDrawSource,
    });
    map.addLayer(mapService.zoomLayer);
    drawZoomBox()
    function drawZoomBox() {
        map.removeInteraction(mapService.drawBox);
        mapService.zoomLayer.getSource().clear();
        mapService.getdrawEnable(true);
        if (counter == 1) {
            addInteraction()
        }
    }

    function addInteraction() {
        mapService.drawBox = new DragBox({
            condition: noModifierKeys,
            className: 'drag',
        });
        map.addInteraction(mapService.drawBox);
        mapService.drawBox.on('boxend', (evt: any) => {
            toolActive = false
            mapService.previousId = null
            map.removeInteraction(mapService.drawBox);
            mapService.zoomLayer.getSource().clear();
            const geom = evt.target.getGeometry();
            const extent = geom.getExtent()
            const size = map.getSize();
            const width = getWidth(extent);
            const height = getHeight(extent);
            mapService.zoomBoxCounter = 0
            if (size[0] / size[1] > width / height) {
                map.getView().fit([extent[0], (extent[1] + extent[3]) / 2, extent[2], (extent[1] + extent[3]) / 2], { constrainResolution: false });
            } else {
                map.getView().fit([(extent[0] + extent[2]) / 2, extent[1], (extent[0] + extent[2]) / 2, extent[3]], { constrainResolution: false });
            }

            mapService.allBtns.forEach((elem: any) => {
                elem.classList.remove('active');
            });
            if (toolName.displayName === 'Metrics') {
                mapService.getdrawEnable(true);
            } else {
                mapService.getdrawEnable(false);
            }
            mapService.mapLayer.removeInteraction(mapService.drawBox);
            mapService.activityLoging('ZoomBox:Go', ipAddress)
        });

    }
}
